// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__KDilk","load8":"loader_load8__wAzMB"};